module.exports = __webpack_public_path__ + "static/img/15.01f8310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/fkw/15.jpg
// module id = yL4v
// module chunks = 1